import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { EMPTY, merge, Subject, throwError } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatSort } from '@angular/material/sort';
import {
  debounceTime,
  catchError,
  switchMap,
  startWith,
  retry,
  map,
} from 'rxjs/operators';
import { SubSink } from 'subsink';
import { AdminOrderPreviewComponent } from '../../dialogs/admin-order-preview/admin-order-preview.component';
import { AdminDocumentPreviewComponent } from '../../dialogs/admin-document-preview/admin-document-preview.component';
import { Order } from 'src/app/shared';
import { OrderService, TitleService } from 'src/app/feature/services';

@Component({
  templateUrl: './admin-orders.component.html',
  styleUrls: ['./admin-orders.component.scss'],
})
export class AdminOrdersComponent implements OnInit {
  @ViewChild(MatDateRangePicker) dateRangePicker!: MatDateRangePicker<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('idSearch') idSearchInput!: MatInput;
  @ViewChild(MatSort) sort!: MatSort;

  public startDate: string = '';
  public endDate: string = '';

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  public refreshController$ = new Subject();
  public searchController$ = new Subject();

  public isRateLimitReached: boolean = false;
  public isLoadingResult: boolean = false;
  public resultsLength: number = 0;

  public dataSource = new MatTableDataSource<Order>();
  public displayedColumns: string[] = [
    'id',
    'status',
    'name',
    'price',
    'user',
    'actions',
  ];

  // ------------------------------------------------Private methods|

  private subsink = new SubSink();
  private previewDialogRef!: MatDialogRef<AdminDocumentPreviewComponent>;

  // ------------------------------------------------Constructor|

  constructor(
    private orderService: OrderService,
    private titleService: TitleService,
    private previewDialog: MatDialog
  ) {
    this.titleService.setTitle('تاریخچه سفارشات');
  }

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;

    merge(
      this.paginator.page,
      this.sort.sortChange,
      this.searchController$.pipe(debounceTime(350)),
      this.refreshController$
      // this.documentTypes.valueChange
    )
      .pipe(
        catchError((err) => {
          this.isLoadingResult = false;
          return throwError(err);
        }),
        startWith({}),
        switchMap((value: any, index: any) => {
          this.isLoadingResult = true; // Start loading

          const order = value?.direction
            ? value.direction.toUpperCase()
            : undefined;

          const search = value?.idSearch ? value.idSearch : undefined;

          return this.orderService
            .loadAll({
              order,
              status: 'calculation',
              orderTarget: order && value?.active ? value.active : undefined,
              startDate: this.range?.value?.start?.toISOString(),
              endDate: this.range?.value?.end?.toISOString(),
              limit: this.paginator.pageSize,
              page: this.paginator.pageIndex + 1,
              search: search,
            })
            .pipe(catchError(() => EMPTY));
        }),
        map((data: any) => {
          this.isLoadingResult = false;
          this.isRateLimitReached = data.items.length === 0;

          if (this.isRateLimitReached) {
            return [];
          }

          this.resultsLength = data.meta.totalItems + 1;
          return data.items;
        }),

        retry(2)
      )
      .pipe(catchError(() => EMPTY))
      .subscribe((data) => (this.dataSource = new MatTableDataSource(data)));
  }

  public preview(order: Order) {
    this.previewDialog.open(AdminOrderPreviewComponent, {
      data: order,
      width: '100%',
      height: '100%',
      maxWidth: '1024px',
      maxHeight: '700px',
    });
  }

  // ---------------------------------------------------------Public methods|

  public getTotalCost(): number {
    if (this.dataSource.data.length <= 0) return 0;
    return +this.dataSource.data
      .map((item) => item.price)
      .reduce((a, b) => (+a + +b) as any);
  }
}
